// coinのrate%分の値を返す
export function calculateBonusAmount(coin: number, rate: number): number {
  // rateやcoinが0以下の場合は0を返す
  if (rate < 0 || coin < 0) {
    return 0
  }
  return Math.floor((coin * rate) / 100)
}
